var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"my-button secondary-font",class:_vm.disabled ? 'my-button-disabled' : '',attrs:{"disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }